import { useAuth } from '../context/AuthContext';
import { useRouter } from '../context/RouterContext';
import AppHeader from '../components/AppHeader';

function LandingPage() {
  const { user, logout } = useAuth();
  const { navigate } = useRouter();

  const menuItems = [
    {
      title: 'Database Vocabularies',
      description: 'Explore vocabularies for controlled fields',
      path: '/vocabularies'
    },
    {
      title: 'Database Schemas',
      description: 'Explore database structure and relationships',
      path: '/schemas'
    },
    {
      title: 'Access Database',
      description: 'Query fundraising deals, capital providers, and borrowers',
      path: '/database'
    }
  ];

  return (
    <div className="landing-page">
      <AppHeader showBackButton={false} />

      <main className="landing-main">
        <img src="/lendport_logo_icon_text.svg" alt="Lendport" className="landing-logo-large" />
        <h1 className="landing-title">Credit Deals Tracker</h1>
        <p className="landing-subtitle">Access database tools and resources</p>

        <div className="landing-menu">
          {menuItems.map((item) => (
            <div
              key={item.path}
              className="landing-menu-item"
              onClick={() => navigate(item.path)}
            >
              <div className="landing-menu-item-content">
                <div className="landing-menu-item-title">{item.title}</div>
                <div className="landing-menu-item-desc">{item.description}</div>
              </div>
              <div className="landing-menu-item-arrow">→</div>
            </div>
          ))}
        </div>
      </main>

      <footer className="landing-footer">
        © {new Date().getFullYear()} Lendport. All rights reserved.
      </footer>
    </div>
  );
}

export default LandingPage;
